import { useState } from "react";
import { s } from "../lib/constants";

export default function SetupScreen({ onKeySubmit, error }) {
  const [key, setKey] = useState("");

  return (
    <div style={s.step}>
      <p style={s.eyebrow}>activation needed</p>
      <p style={s.display}>This app needs an AI key to run</p>
      <p style={s.body}>
        The app is powered by Groq — a free AI service. Whoever activates it keeps it running for everyone.
        It takes about 2 minutes and costs nothing.
      </p>

      <div style={styles.steps}>
        <div style={styles.stepItem}>
          <span style={styles.stepNum}>1</span>
          <span style={styles.stepText}>Go to <a href="https://console.groq.com" target="_blank" rel="noreferrer" style={styles.link}>console.groq.com</a> and create a free account</span>
        </div>
        <div style={styles.stepItem}>
          <span style={styles.stepNum}>2</span>
          <span style={styles.stepText}>Go to <strong style={{ color: "#e8e2d4" }}>API Keys</strong> → click <strong style={{ color: "#e8e2d4" }}>Create API Key</strong></span>
        </div>
        <div style={styles.stepItem}>
          <span style={styles.stepNum}>3</span>
          <span style={styles.stepText}>Copy the key and paste it below — it activates the app for everyone</span>
        </div>
      </div>

      {error && <div style={s.errorBox}>{error}</div>}

      <input
        style={s.input}
        type="password"
        value={key}
        onChange={e => setKey(e.target.value)}
        placeholder="Paste your Groq API key here"
      />
      <button
        style={{ ...s.btnPrimary, alignSelf: "flex-end", opacity: key.trim() ? 1 : 0.4 }}
        onClick={() => onKeySubmit(key.trim())}
        disabled={!key.trim()}
      >
        Activate
      </button>
    </div>
  );
}

const styles = {
  steps: {
    display: "flex",
    flexDirection: "column",
    gap: "0.9rem",
    background: "#131a14",
    border: "1px solid #2a3a2b",
    borderRadius: 10,
    padding: "1.25rem",
  },
  stepItem: {
    display: "flex",
    gap: "0.9rem",
    alignItems: "flex-start",
  },
  stepNum: {
    flexShrink: 0,
    width: 22,
    height: 22,
    background: "#c8924a",
    color: "#0e1410",
    borderRadius: "50%",
    fontSize: "0.72rem",
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  stepText: {
    fontSize: "0.88rem",
    color: "#8a9a8b",
    lineHeight: 1.6,
  },
  link: {
    color: "#7a9e7e",
    textDecoration: "underline",
    textUnderlineOffset: 3,
  },
};
